// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IFsm","col":"styles_col__1v7XP"};